import { createReducer } from "@reduxjs/toolkit";
import { resetRetrieveProviderStudio, retrieveProviderStudio } from "./retrieve-provider-studio";
import type { RetrievalState } from "@redux/state/shared-types";
import type { ProviderStudioListItem } from "@shared-kernel/application/ports/provider/provider-repository";

const initialState: RetrievalState<ProviderStudioListItem | null> = {
  fetching: "idle",
  data: null,
};

export const retrieveProviderStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(retrieveProviderStudio.pending, state => {
      state.fetching = "pending";
    })
    .addCase(retrieveProviderStudio.fulfilled, (state, action) => {
      state.fetching = "success";
      state.data = action.payload;
    })
    .addCase(retrieveProviderStudio.rejected, state => {
      state.fetching = "failed";
    })
    .addCase(resetRetrieveProviderStudio, () => {
      return initialState;
    });
});
